import { render, staticRenderFns } from "./image-map.vue?vue&type=template&id=08a5e95b&scoped=true"
import script from "./image-map.vue?vue&type=script&lang=js"
export * from "./image-map.vue?vue&type=script&lang=js"
import style0 from "./image-map.vue?vue&type=style&index=0&id=08a5e95b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a5e95b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/release/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a5e95b')) {
      api.createRecord('08a5e95b', component.options)
    } else {
      api.reload('08a5e95b', component.options)
    }
    module.hot.accept("./image-map.vue?vue&type=template&id=08a5e95b&scoped=true", function () {
      api.rerender('08a5e95b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/renderers/image-map-view-renderer/image-map.vue"
export default component.exports